import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoFaceid16 = t0 => {
  const $ = _c(9);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <g><path d="M5.5 2.5H3.16667C2.79848 2.5 2.5 2.79848 2.5 3.16667V5.5M2.5 10.5V12.8333C2.5 13.2015 2.79848 13.5 3.16667 13.5H5.5M10.5 2.5H12.8333C13.2015 2.5 13.5 2.79848 13.5 3.16667V5.5M13.5 10.5V12.8333C13.5 13.2015 13.2015 13.5 12.8333 13.5H10.5M8.16667 5.83333V7.33333C8.16667 8.01327 7.65773 8.57433 7 8.65633M5.16667 5.83333V6.83333M10.8333 5.83333V6.83333M6 10.4649C6.58835 10.8052 7.2714 11 8 11C8.7286 11 9.41167 10.8052 10 10.4649" stroke={iconColor} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2) {
    t4 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default IcoFaceid16;